import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Subscription} from 'rxjs';
import {Role} from '../../model/auth/Role';
import {AuthService} from '../../service/auth.service';
import {Session} from '../../model/auth/Session';
import {UrlHelper} from '../../helper/url.helper';
import {Router} from '@angular/router';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'permission-checker',
  templateUrl: './permission-checker.component.html',
  styleUrls: ['./permission-checker.component.scss']
})
export class PermissionCheckerComponent implements OnInit, OnDestroy {

  @Input() roles!: Role[];

  @Output() contentInit = new EventEmitter<void>();
  @Output() rolesLoaded = new EventEmitter<Role[]>();

  private session?: Session | null;

  private subscription!: Subscription;

  constructor(private authService: AuthService,
              private router: Router) {
  }

  async ngOnInit() {
    this.subscription = this.authService.userChanged.subscribe(() => {
      void this.authService.getSession().then(session => {
        this.session = session;

        this.propageteRoles();
      });
    });

    this.session = await this.authService.getSession();

    if (this.session && !this.session.role) {
      await this.router.navigate([UrlHelper.ROLE_SELECT_PATH]);
    } else if (this.hasPermission) {
      this.propageteRoles();

      this.contentInit.emit();
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private propageteRoles(): void {
    if (this.session && this.session.role) {
      this.rolesLoaded.emit([this.session.role]);
    }
  }

  get hasPermission() {
    return this.session
      && this.session.role
      && this.roles.includes(this.session.role);
  }
}
